module.exports = __webpack_public_path__ + "static/media/campaign-2022.d3bdd239.png";